// extracted by mini-css-extract-plugin
module.exports = {"TutorialsCard":"TutorialsCard_TutorialsCard__2s4MS","Content":"TutorialsCard_Content__CpJds","Info":"TutorialsCard_Info__71UDF","Footer":"TutorialsCard_Footer__CQSOh"};